import axios from 'axios';

export const sendContactMail = (payload) => axios.post('/mail/sendContact', payload);
export const sendResetPasswordMail = (payload) => axios.post('/mail/sendResetPassword', payload);
